import { beginTask, endTask } from 'redux-nprogress';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectFormulasState } from '../../../../store/reducers/formula';
import {
  selectPositionsState,
  selectPositionsStatsMap,
  getPositionsStatsMap,
 } from '../../../../store/reducers/positions';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'projections';
export const selectProjectionsState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  ranking: [],
  year: null,
  week: null,
  position: '',
  formulaId: null,
  hasLoaded: false,
  error: null,
  lastUpdatedAt: null,
};

const projectionsReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default projectionsReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_PROJECTIONS_REQUEST = `${STORE_KEY}/LOAD_PROJECTIONS_REQUEST`;
export const LOAD_PROJECTIONS_SUCCESS = `${STORE_KEY}/LOAD_PROJECTIONS_SUCCESS`;
export const LOAD_PROJECTIONS_ERROR = `${STORE_KEY}/LOAD_PROJECTIONS_ERROR`;

export const loadProjectionsRequest = ({ year, week, position, formulaId }) => ({
  type: LOAD_PROJECTIONS_REQUEST,
  payload: { year, week, position, formulaId },
});
export const loadProjectionsSuccess = ({ ranking, last_updated_at: lastUpdatedAt }) => ({
  type: LOAD_PROJECTIONS_SUCCESS,
  payload: { ranking, lastUpdatedAt },
});
export const loadProjectionsError = error => ({
  type: LOAD_PROJECTIONS_ERROR,
  payload: { error },
});

actions[LOAD_PROJECTIONS_REQUEST] = (
  state,
  { payload: { year, week, position, formulaId } },
) => ({ ...state,
  year,
  week,
  position,
  formulaId,
});
actions[LOAD_PROJECTIONS_SUCCESS] = (state, { payload: { ranking, lastUpdatedAt } }) => ({ ...state,
  lastUpdatedAt,
  ranking,
  hasLoaded: true,
});
actions[LOAD_PROJECTIONS_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
});

export const loadProjections = (
  { year, week, position, formulaId },
) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadProjectionsRequest({ year, week, position, formulaId }));
    const projections = await api.projections.getPlayerProjections(
      { year, week, position, formulaId },
    );
    dispatch(loadProjectionsSuccess(projections));
  } catch (error) {
    console.error(error);
    dispatch(loadProjectionsError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const PROJECTIONS_VIEW = `${STORE_KEY}/PROJECTIONS_VIEW`;
export const PROJ_PRESEASON_POSITION_STATS_MAP_KEY = 'player-projections-preseason';
export const PROJ_WEEKLY_POSITION_STATS_MAP_KEY = 'player-projections-weekly';
viewNames[PROJECTIONS_VIEW] = 'PlayerProjections';
routes[PROJECTIONS_VIEW] = {
  path: '/fantasy-football-projections',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { year, formulaId, week, position } = selectQuery(state);
    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;
    if (year === null || year === undefined || year === 'null') year = currentYear;
    await dispatch(loadWeeks(year));

    const projectionsWeeks = [0].concat(selectWeeks(getState(), year, 'projections'));
    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = projectionsWeeks[0];
      }
    }

    if (!(projectionsWeeks.includes(week))) {
      week = projectionsWeeks[0] || 0;
    }

    if (!position) position = selectPositionsState(state).projections[0];

    const key = (week === 0) ?
      PROJ_PRESEASON_POSITION_STATS_MAP_KEY :
      PROJ_WEEKLY_POSITION_STATS_MAP_KEY;
    let positionsStatsMap = selectPositionsStatsMap(state, key);
    if (!positionsStatsMap) {
      await dispatch(getPositionsStatsMap(key));
      positionsStatsMap = selectPositionsStatsMap(getState(), key);
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadProjections({ year, week, position, formulaId }));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/PlayerProjections/module/projections.js